export default {
  computed: {
    user() { return this.$store.state.user; },
    loading() { return this.$store.state.loading; },
    surveys() { return this.$store.state.surveys.surveys || []; },
    testBonusesList() { return this.$store.state.courses.testBonusesList || []; },
  },
  methods: {
    getSurvey(id) {
      this.$router.push(`/survey/${id}`);
    },
  },
  created() {
    this.user && this.user.profile_id && this.$store
      .dispatch('surveys/GetSurveysList', {
        profile_id: this.user.profile_id,
        period_id: null,
      });
  },
};
